import { render, staticRenderFns } from "./EmailDetailModal.vue?vue&type=template&id=3cc0a33f&scoped=true"
import script from "./EmailDetailModal.vue?vue&type=script&lang=js"
export * from "./EmailDetailModal.vue?vue&type=script&lang=js"
import style0 from "./EmailDetailModal.vue?vue&type=style&index=0&id=3cc0a33f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc0a33f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cc0a33f')) {
      api.createRecord('3cc0a33f', component.options)
    } else {
      api.reload('3cc0a33f', component.options)
    }
    module.hot.accept("./EmailDetailModal.vue?vue&type=template&id=3cc0a33f&scoped=true", function () {
      api.rerender('3cc0a33f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/components/campusPreview/EmailDetailModal.vue"
export default component.exports